import React, { FunctionComponent, useMemo } from 'react';

import Text from '@gojob/ui-bits/Text';
import useDateFormat from '../../translations/useDateFormat';

export type MarksProps = {
  publicationDate?: string;
  media?: string;
};

const Marks: FunctionComponent<MarksProps> = (props) => {
  const { publicationDate, media } = props;

  const dateFormat = useDateFormat();
  const date = useMemo(() => {
    if (publicationDate) {
      return dateFormat(Date.parse(publicationDate), 'd MMMM yyyy');
    }
    return '';
  }, [publicationDate, dateFormat]);

  const content = useMemo(() => {
    return [date, media].filter((data) => !!data).join(' - ');
  }, [date, media]);

  if (!publicationDate && !media) {
    return null;
  }
  return <Text variant="message4">{content}</Text>;
};

export default Marks;
